import { Route } from 'react-router-dom';

import { Dashboard } from 'src/views/dashboard';
import { HomePage } from 'src/views/homePage';
import { Settings } from 'src/views/personal/settings';

export const Routes = {
  home: '/home',
  console: '/console',
  settings: `/me/settings`,
};

export const ROUTES = [
  <Route key='home' path={Routes.home} element={<HomePage />} />,
  <Route key='console' path={Routes.console} element={<Dashboard />} />,
  <Route key='settings' path={Routes.settings} element={<Settings />} />,
];
